import _ from 'lodash';

import DEACTIVATE_CUSTOMER_ADMIN_TAB from '../../models/deactivateCustomerAdminTab.js';

class DeactivateCustomerAdminController {
  constructor(userAccountService, modalLoaderService, customer) {
    this.name = 'deactivateCustomerAdmin';
    this.tabs = DEACTIVATE_CUSTOMER_ADMIN_TAB;
    this.modalLoaderService = modalLoaderService;
    this.userAccountService = userAccountService;
    this.setErrorSuccessMsgDefaults();
    this.RESPONSE_MESSAGES = {
      success: 'Deletion successful'
    };
    userAccountService.getCustomerAdminDetails(customer.id)
      .then(this.onGetUserDetailsSuccess.bind(this), this.onGetUserDetailsFailure.bind(this));

    this.selectedValues = [];

    this.metaData = {
      deactivateCustomerAdmin: {
        selectedValues: this.selectedValues
      }
    };
    this.options = this.tabs.options;
  }

  setErrorSuccessMsgDefaults() {
    this.isRequestSuccessful = false;
    this.isRequestFailure = false;
  }

  onGetUserDetailsSuccess(response) {
    this.data = response.data;
  }

  onGetUserDetailsFailure() {}

  cancel() {
    this.modalLoaderService.close();
  }

  deactivateCustomerAdmin() {
    this.userAccountService.deactivateCustomerAdmins(this.selectedValues)
      .then(this.onDeactivateCustomerAdminsSuccess.bind(this), this.onDeactivateCustomerAdminsFailure.bind(this));
  }

  onDeactivateCustomerAdminsSuccess(response) {
    this.removeSelectedValues();
    this.selectedValues = [];

    if (response.data.message === this.RESPONSE_MESSAGES.success) {
      this.isRequestSuccessful = true;
      this.selectedValues = [];
    }
  }

  removeSelectedValues() {
    _.each(this.selectedValues, (selectedId) => {
      _.remove(this.data.content, (value) => {

        return value.id === selectedId;
      });
    });
  }

  onDeactivateCustomerAdminsFailure() {
    this.isRequestFailure = true;
  }

  isDeactivateButtonDisabled() {
    let isButtonDisabled = !(!!this.selectedValues && this.selectedValues.length > 0);
    return isButtonDisabled;
  }
}

DeactivateCustomerAdminController.$inject = ['userAccountService', 'modalLoaderService', 'customer'];

export
default DeactivateCustomerAdminController;



// WEBPACK FOOTER //
// ./app/components/deactivateCustomerAdmin/deactivateCustomerAdmin.controller.js